import ScoreByTopics from './ScoreByTopics.gql';

export default ScoreByTopics;
